import { inject, Injectable, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

const APP_NAME = 'Księgowskaz Master';

@Injectable({ providedIn: 'root' })
export class TranslocoTitleStrategy extends TitleStrategy implements OnDestroy {
  private readonly title = inject(Title);
  private readonly transloco = inject(TranslocoService);
  private lastSnapshot: RouterStateSnapshot | null = null;
  private langSub: Subscription;

  constructor() {
    super();
    this.langSub = this.transloco.langChanges$.subscribe(() => {
      if (this.lastSnapshot) {
        this.updateTitle(this.lastSnapshot);
      }
    });
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.lastSnapshot = snapshot;
    const key = this.buildTitle(snapshot);
    if (key) {
      this.transloco.selectTranslate(key).subscribe((translated) => {
        this.title.setTitle(`${translated} | ${APP_NAME}`);
      });
    } else {
      this.title.setTitle(APP_NAME);
    }
  }

  ngOnDestroy(): void {
    this.langSub.unsubscribe();
  }
}
